/** Normalize color string for CSS `background` (hex with/without `#`, or rgb/rgba). */
export const toCssHex = (color?: string): string | undefined => {
    if (!color) return undefined
    if (color.startsWith('#') || color.startsWith('rgb')) return color
    return `#${color}`
}

/** Strip leading `#` if present. */
export const stripHexHash = (hex?: string): string => {
    if (!hex) return ''
    return hex.startsWith('#') ? hex.slice(1) : hex
}
